import React from "react";
import Brick from './BrickCore';
import ContextSetDataOptionsForm from './ContextSetDataOptionsForm';

/** Class representing a workflow brick to
 * initialize some context data.
 *
 * [server_side]
 */
class ContextSetData extends Brick {
    /**
     * Get this brick options form
     *
     * @param {Object} props: an object with the following keys
     *                          - t
     *                          - workflow
     *                          - forms
     *                          - emails
     *                          - articles
     *                          - salepoints
     */
    getOptionsForm(props) {
        const { workflow } = props;

        if (!workflow?.bricks?.length)
            return null;

        return <ContextSetDataOptionsForm brick={this} workflow={workflow} t={props.t} />;
    }
}

export default ContextSetData;
